export function addParamToCurrentUrl(paramName: string, paramValue: string) {
  const params = new URLSearchParams(window.location.search);
  params.set(paramName, paramValue);
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState({}, '', newUrl);
}

export function removeParamFromCurrentUrl(paramName: string) {
  const params = new URLSearchParams(window.location.search);
  if (params.has(paramName)) {
    params.delete(paramName);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }
}

export function buildURLWithParams(
  baseURL: string | URL,
  params: Record<string, string | number | boolean | null | undefined>
): URL {
  const url = new URL(baseURL);

  for (const [key, value] of Object.entries(params)) {
    if (value != null) {
      url.searchParams.append(key, String(value));
    }
  }

  return url;
}
